import script from "./SelectVoicesView.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectVoicesView.vue?vue&type=script&setup=true&lang=js"

import "./SelectVoicesView.vue?vue&type=style&index=0&id=0e670b6e&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e670b6e"]])

export default __exports__